import React from 'react'
import styled from '../../styled'
import { Typography } from '@yanolja-org/ya-com-core'

const TabItem = styled.div<{ filled: boolean; itemLen: number }>`
  float: left;
  padding-left: ${({ filled }) => (filled ? '0' : '2rem')};
  text-align: center;

  ${({ filled, itemLen }) =>
    filled && {
      width: `calc(100% / ${itemLen} - 4px)`,
    }}

  &:first-of-type {
    padding-left: 0;
  }
`

const Label = styled.div<{ height?: string }>`
  text-align: center;
  ${Typography('body1').regular};
  line-height: ${({ height }) => height || '3.2rem'};
  color: ${({ theme }) => theme.color.gray600};
  cursor: pointer;
  white-space: nowrap;

  &.active div {
    ${Typography('body1').bold};
    color: ${({ theme }) => theme.color.gray900};
    border-bottom: 0.2rem solid ${({ theme }) => theme.color.gray900};
    line-height: ${({ height }) => (height ? `calc(${height} - 0.2rem)` : '3rem')};
  }
`

const TabContainer = styled.div<{ height?: string }>`
  position: relative;
  width: 100%;
  height: ${({ height }) => height || '3.2rem'};
  border-bottom: 0.1rem solid ${({ theme }) => theme.color.gray200};
  background-color: ${({ theme }) => theme.color.white};
  &.borderless {
    border-bottom: none;
  }
`
const TabItemContainer = styled.div<{ height?: string }>`
  padding: 0 2rem;
  height: ${({ height }) => height || '3.2rem'};
  margin: 0 auto;
  max-width: ${({ theme }) => theme.unit.PC_WIDTH}px;
`

interface ITabs<T> {
  label: string
  value: T
}

interface TabsProps<T> {
  tabs: Array<ITabs<T>>
  currentTab: T
  filled?: boolean
  onTabChangeHandler: (val: T) => void
  borderless?: boolean
  height?: string
}

const Tabs = <T extends string | number = string>({
  tabs,
  currentTab,
  filled,
  onTabChangeHandler,
  borderless,
  height,
}: TabsProps<T>) => {
  const items = tabs.map((v, i) => (
    <TabItem
      key={`tab_${i}`}
      filled={filled || false}
      itemLen={tabs.length}
      onClick={() => onTabChangeHandler(v.value)}
    >
      <Label height={height} className={currentTab === v.value ? 'active' : ''}>
        {/* Parent 에서 label style over ride 를 위한 className 지정 */}
        <div className={'label'}>{v.label}</div>
      </Label>
    </TabItem>
  ))
  return (
    <TabContainer className={borderless ? 'borderless' : ''} height={height}>
      <TabItemContainer height={height}>{items}</TabItemContainer>
    </TabContainer>
  )
}

export default Tabs
